var _defs, _tspan, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs128(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "94.074066mm",
    height: "132.29167mm",
    viewBox: "0 0 94.074066 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-7.22185e-8,-164.70834)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uF5F3",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(1.358021,0,0,1.358021,-2.6131698,-104.3957)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 2.2850449,221.37021 c 0,0 -0.3607964,0.48106 -0.3607964,1.20265 0,0.48107 0.2405309,1.08239 1.0823892,1.32292 0.3607964,0.12027 0.7215929,0.24053 0.8418583,0.24053 0.9621238,0 1.3229202,-0.84185 1.3229202,-0.84185 0,0 4.2092916,-6.73487 5.1714158,-8.53885 0.481061,-0.60133 0.841858,-0.96213 0.962123,-0.96213 0.481062,0 0.601328,0.84186 0.601328,1.32292 v 24.89496 c 0,2.16478 -2.1647788,3.60796 -4.2092919,3.60796 -0.7215928,0 -1.6837166,0.3608 -1.6837166,1.44319 0,1.08239 0.9621238,1.56345 2.1647785,1.56345 h 20.44513 c 1.563451,0 1.563451,-1.56345 1.563451,-1.56345 0,0 0,-1.44319 -1.443185,-1.44319 -1.32292,0 -3.006637,-1.68372 -3.006637,-3.36743 v -39.56734 c 0,-1.56345 -0.601327,-2.16478 -1.924248,-2.28505 -1.443185,0 -3.848495,0.3608 -5.051149,0.3608 -1.803982,0 -3.607965,0 -5.05115,-0.24053 -0.120266,0 -0.360797,-0.12027 -0.481062,-0.12027 -0.962124,0 -1.32292,0.96213 -1.683717,1.80399 z m 68.4310541,9.98203 c 0,-1.20265 -0.481062,-1.32292 -1.202655,-1.32292 -0.721593,0 -0.962124,0.3608 -1.202655,0.96213 0,0 -0.120265,0.12026 -0.120265,0.24053 -0.962124,2.28504 -1.683717,4.08902 -3.72823,4.08902 -0.481062,0 -0.962124,0 -1.683716,-0.24053 -1.202655,-0.48106 -1.924248,-0.60132 -2.886372,-1.08239 -1.924247,-0.72159 -6.37407,-2.28504 -10.34283,-2.28504 -1.202655,0 -2.525575,0.24053 -3.607965,0.60133 2.164779,-3.4877 10.342831,-6.37407 12.50761,-6.9754 1.443185,-0.3608 5.411946,-1.08239 8.659114,-3.72823 2.285043,-1.80398 4.089026,-4.57009 4.089026,-8.89964 0,-4.44983 -1.924248,-7.697 -4.449823,-9.86177 -4.930884,-4.08903 -12.387344,-4.69036 -14.552122,-4.69036 -2.525575,0 -5.772743,0.12027 -8.298318,0.60133 -3.367433,0.72159 -6.734866,2.76611 -9.01991,5.41195 -1.683717,2.04451 -2.766106,4.44982 -2.766106,7.09566 0,1.32292 0.360796,2.64584 0.841858,4.08903 1.443186,3.00663 4.449823,5.29168 7.937522,5.29168 5.893008,0 6.734866,-6.01328 6.734866,-8.41859 0,-5.77274 -6.614601,-6.13354 -6.614601,-8.05778 0.120265,-1.32292 1.924248,-3.60797 7.576725,-3.60797 8.538848,0 8.659114,6.37407 8.659114,9.26044 0,3.60797 -1.202655,6.9754 -3.247168,9.74151 -3.487699,4.69035 -6.133539,6.97539 -10.944158,9.86177 -5.291681,3.36743 -9.01991,8.05778 -10.583362,14.07106 0,0.24053 -0.120265,0.48106 -0.120265,0.60132 0,1.08239 0.601327,2.28505 1.683717,3.00664 0.360796,0.24053 0.601327,0.24053 0.841858,0.24053 2.044513,0 3.247168,-5.89301 8.899645,-5.89301 3.848495,0 5.291681,5.17142 13.830529,5.17142 4.209292,0 11.545486,-0.3608 13.108937,-15.27372 z m -21.407254,35.83911 c 3.367433,-2.16477 5.772742,-5.41194 5.772742,-10.22256 0,-9.7415 -14.191325,-11.18469 -16.837166,-11.18469 -11.064423,0 -18.761414,5.05115 -18.761414,13.10894 0,6.73486 3.848496,10.22256 8.418584,12.8684 -5.05115,2.40531 -8.899645,5.53221 -8.899645,11.66575 0,8.29832 8.659114,12.14682 18.280351,12.14682 9.621238,0 19.843803,-4.08903 19.843803,-17.0777 0,-5.77274 -3.367433,-9.01991 -7.817255,-11.30496 z m -12.50761,25.25575 c -6.37407,0 -12.267078,-3.24716 -12.267078,-9.50097 0,-3.84849 3.367434,-7.45646 7.576725,-9.14017 7.095663,3.1269 14.191326,5.17141 14.191326,11.54548 0,3.8485 -3.006637,7.09566 -9.500973,7.09566 z m 7.45646,-27.42052 c -7.69699,-2.76611 -15.875043,-4.32956 -15.875043,-10.4631 0,-3.96876 5.532212,-6.01327 9.741504,-6.01327 3.006636,0 11.184689,1.56345 11.184689,8.29831 0,3.8485 -1.924248,6.37407 -5.05115,8.17806 z",
    id: "path4631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs128);
export default __webpack_public_path__ + "static/media/ts-12-8.1a4ddb408eb6ffc8decca02d1d371d88.svg";
export { ForwardRef as ReactComponent };